import {BreakpointObserver, BreakpointState} from '@angular/cdk/layout';
import {DestroyRef, inject, Inject, Injectable, OnDestroy, PLATFORM_ID} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {isPlatformServer} from '@angular/common';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

export enum AppLayoutType {
	XS, SM, MD, LG, XL
}

export const AppLayouts = [
	AppLayoutType.XL,
	AppLayoutType.LG,
	AppLayoutType.MD,
	AppLayoutType.SM,
	AppLayoutType.XS,
];

export type MediaQuery = string;

@Injectable({providedIn: 'root'})
export class AppLayoutService implements OnDestroy {

	readonly layout: AppLayoutType = AppLayoutType.MD;
	readonly layoutChange: BehaviorSubject<AppLayoutType> = new BehaviorSubject<AppLayoutType>(AppLayoutType.MD);
	protected breakpointMap: Map<AppLayoutType, MediaQuery> = new Map([
		[AppLayoutType.XS, 'screen and (min-width: 0px)'],
		[AppLayoutType.SM, 'screen and (min-width: 600px)'],
		[AppLayoutType.MD, 'screen and (min-width: 960px)'],
		[AppLayoutType.LG, 'screen and (min-width: 1280px)'],
		[AppLayoutType.XL, 'screen and (min-width: 1920px)'],
	]);

	constructor(@Inject(PLATFORM_ID) platformId: Object, destroyRef: DestroyRef) {
		if(isPlatformServer(platformId)) return;
		const breakpointObserver = inject(BreakpointObserver);

		this.layout = AppLayouts.find((layoutType: AppLayoutType) => breakpointObserver.isMatched(this.breakpointMap.get(layoutType)!)) ?? AppLayoutType.MD;
		this.layoutChange.next(this.layout);

		breakpointObserver.observe(Array.from(this.breakpointMap.values())).pipe(
			filter((state: BreakpointState) => !!state),
			takeUntilDestroyed(destroyRef),
		).subscribe((state: BreakpointState) => {

			for(const layout of AppLayouts) {
				const mediaQuery = this.breakpointMap.get(layout)!;
				if(state.breakpoints[mediaQuery]) {
					this.layoutChange.next(layout);
					break;
				}
			}
		});
	}

	get currentLayout(): AppLayoutType {
		return this.layoutChange.value;
	}

	ngOnDestroy(): void {
		this.layoutChange.complete();
	}

}
